import { type FC, type ReactNode } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';

import { StringSmall } from '@/components/Typography/Typography';

import css from './styles.module.scss';

const statusDescriptionVariants = cva('', {
  variants: {
    variant: {
      default:
        'h-6 flex items-center justify-center gap-[2px] rounded-[80px] bg-[#1D1F25]/60',
      extend: css.expiredDescription,
    },
  },
});

interface StatusDescriptionProps
  extends VariantProps<typeof statusDescriptionVariants> {
  className?: string;
  text: string;
  icon?: () => ReactNode;
}

const StatusDescription: FC<StatusDescriptionProps> = ({
  className,
  text,
  icon,
  variant = 'default',
}) => {
  return (
    <div className={cn(statusDescriptionVariants({ variant }), className)}>
      <StringSmall weight="bold">{text}</StringSmall>
      {icon && icon()}
    </div>
  );
};

export { StatusDescription };
